export default __webpack_public_path__ + "media/bundles/App/layout/intro-background-adccd04d15ed5dd1cb17cdef77a37a15.png";